var ko = require('knockout');
var analytics = require('_js/analytics-ecommerce');

function Model(params) {
  var self = this;
  self.text = params.text;
  self.addedText = params.addedText;
  self.course = params.course;
  self.isCompact = params.isCompact;
  self.notifyChangeInCategory = params.notify ? true : false;

  if (!self.course.IsPurchased || !ko.isObservable(self.course.IsPurchased)) {
    self.course.IsPurchased = ko.observable(!!self.course.IsPurchased);
  }

  self.isPurchased = ko.pureComputed({
    read: function () {
      return self.course.IsPurchased();
    },
    write: function (value) {
      self.course.IsPurchased(value);
    }
  });

  self.isInArticle = ko.observable(params.isInArticle);
  self.quickPurchaseOnlineCourse = params.quickPurchaseOnlineCourse;
  self.loading = ko.observable(false);
  self.purchase = function() {
    if (self.isPurchased()) return;

    self.loading(true);

    $.post(self.quickPurchaseOnlineCourse + '?sequenceKey=' + self.course.Key)
      .success(function(result) {
        self.course.IsPurchased(result);
        self.loading(false);
        ko.postbox.publish('changeInCategoryRequirement', result);

        if (result) {
          var pseudoCart = {
            courses: [Object.assign({}, self.course, { participants: [{}] })]
          };
          analytics.productAddedToCart(self.course, 1, undefined, 'QuickPurchase');
          analytics.purchaseFinished(
            'quickpurchase-' + self.course.Id + '-' + Date.now(),
            pseudoCart
          );
        }
      })
      .fail(function(err) {
        self.loading(false);
      });
  };

  // Set isPurchased to false when receiving a course that matches 'params.course' on the 'removeCourse' topic.
  ko.postbox.subscribe(
    'removeCourse',
    function(course) {
      if (course.Id === self.course.Id) {
        self.course.IsPurchased(false);
      }
      if (self.isInArticle()) {
        self.isInArticle(true);
      }
    },
    null,
    self
  );
}

module.exports = Model;
